var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1018_211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8.5,
    width: 44,
    height: 44,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6009 20.8989C35.269 20.5669 34.7308 20.5669 34.3989 20.8989C34.0669 21.2308 34.0669 21.769 34.3989 22.1009L38.9478 26.6499H27.9999C26.4484 26.6499 24.9604 27.2662 23.8633 28.3633C22.7662 29.4604 22.1499 30.9484 22.1499 32.4999C22.1499 34.0514 22.7662 35.5394 23.8633 36.6365C24.9604 37.7336 26.4484 38.3499 27.9999 38.3499H34.9999C35.4693 38.3499 35.8499 37.9693 35.8499 37.4999C35.8499 37.0305 35.4693 36.6499 34.9999 36.6499H27.9999C26.8993 36.6499 25.8437 36.2127 25.0654 35.4344C24.2871 34.6561 23.8499 33.6006 23.8499 32.4999C23.8499 31.3993 24.2871 30.3437 25.0654 29.5654C25.8437 28.7871 26.8993 28.3499 27.9999 28.3499H38.9478L34.3989 32.8989C34.0669 33.2308 34.0669 33.769 34.3989 34.1009C34.7308 34.4329 35.269 34.4329 35.6009 34.1009L41.6009 28.1009C41.9329 27.769 41.9329 27.2308 41.6009 26.8989L35.6009 20.8989Z",
    fill: "#5E72E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1018_211",
    x: 0,
    y: 0.5,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.552941 0 0 0 0 0.709804 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1018_211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1018_211",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/requestIcon.df40dcd85cb79aa73d50b9fca96f9279.svg";
export { ForwardRef as ReactComponent };